<script setup lang="ts">
import { getCorrectnessActionGroups } from '@/helpers/constants'
import type { CorrectnesGroups } from '@/types/basic'

export interface Action {
  action: string
  correctness: null | string
}

export interface Actions {
  preflop_actions: Action[]
  flop_actions: Action[]
  turn_actions: Action[]
  river_actions: Action[]
}

interface StreetActionsCompactedV2Props {
  streets: Actions
}

const props = defineProps<StreetActionsCompactedV2Props>()

const getAction = (actions: Action[], renameToBet = false) => {
  // TODO remove as Record<string, any> when constants.js are rewritten to ts
  const cgs = getCorrectnessActionGroups() as CorrectnesGroups
  const res = actions.map(a => {
    let correctnessStr = a.correctness?.toString()
    correctnessStr = (correctnessStr === 'UNSOLVED' ? 'na' : correctnessStr || '').toLowerCase()

    const correctness = cgs[correctnessStr]

    const action_id = a.action.substring(0, 1)
    const span = correctness
      ? `<span style="color:var(${correctness.color})">${action_id}</span>`
      : action_id
    return {
      ...a,
      correctness,
      action_id,
      span,
    }
  })
  let resString = res.map(i => i.span).join(' ')
  if (renameToBet) {
    resString = resString.replace(/R/g, 'B')
  }
  return resString
}

const getStreetActions = (street: keyof Actions) => props.streets[street]

const hasActions = (street: string) => {
  const actionsKey = `${street}_actions` as keyof Actions
  return getStreetActions(actionsKey).length > 0
}
</script>

<template>
  <div
    class="d-flex"
    style="max-height: 100%; overflow: hidden"
  >
    <div
      v-for="street in ['preflop', 'flop', 'turn', 'river'].filter(street => hasActions(street))"
      :key="street"
      class="street-container"
    >
      <div class="street-name">{{ $t(`table_head.${street}`) }}</div>
      <span v-html="getAction(getStreetActions(`${street}_actions` as keyof Actions))"></span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.street-name {
  letter-spacing: 0px;
  position: relative;
  display: flex;
  align-items: center;
  line-height: 1;
  color: var(--clr-grey-2);
  &::first-letter {
    text-transform: capitalize !important;
  }
  font-size: 0.8rem;
  height: 0.7rem;
  margin-bottom: 0.125rem;
}
.street-container {
  position: relative;
  padding: 0 1rem 0 0;
  max-height: 2.2rem;
  position: relative;
  letter-spacing: -0.5px;
  font-size: 0.925rem;
  line-height: 1;
  font-weight: 500;
  word-wrap: none;
  white-space: nowrap;
}
</style>
